<template>
	<div class="loading"></div>
</template>
<script>
export default {
	name: 'LoadSubmit'
}
</script>
<style>
.loading {
	width: 30px;
	height: 30px;
	margin: 0 auto;
	border-radius: 30px;
	box-sizing: border-box;
	border: solid 4px rgba(255, 255, 255, 0.2);
	border-top-color: #fff;
	animation: spin 1s infinite linear;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
